import { filterConfigs } from '@aibees/elephant/feature/search-filters';
import { SearchFilter } from '@aibees/elephant/feature/search-filters/types';
import { SearchTable } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';
import { useMemo } from 'react';

function findParentByField(
  array: SearchFilter[],
  field: string,
  parent?: SearchFilter
): SearchFilter | undefined {
  for (const item of array) {
    if (item.field === field) return parent;
    if (item.items?.length) {
      const found = findParentByField(item.items, field, item);
      if (found) return found;
    }
  }
  return undefined;
}

export function useFilterParent(
  searchTable: Maybe<SearchTable>,
  field: string
): SearchFilter | undefined {
  return useMemo(() => {
    if (!searchTable || !field) return undefined;
    return findParentByField(
      filterConfigs[searchTable] as SearchFilter[],
      field
    );
  }, [searchTable, field]);
}
